import React from "react";
import * as THREE from "three";

const MastWallNone = ({ column, gridScale, colorList, luminaires }) => {
    const { height = 6, point, positionAngle = 0 } = column.values;
    const { x, y } = point;
    const defaultBaseColor = "lightgray";
    const columnBaseZ = (height * gridScale) / 2;

    const { lanterns = [] } = column.values;

    const offsets = lanterns.map(l => parseFloat(l.offset) || 0);
    let width = 0.4;
    let centerOffset = 0;
    let adjustedX = x;

    if (offsets.length === 1) {
        centerOffset = offsets[0];
        adjustedX = x + centerOffset;
    } else {
        const minOffset = Math.min(...offsets);
        const maxOffset = Math.max(...offsets);
        width = Math.max(0.4, maxOffset - minOffset) + 0.4;
        centerOffset = (maxOffset + minOffset) / 2;
        adjustedX = x + centerOffset;
    }

    const groupPosition = [
        adjustedX * gridScale,
        y * gridScale * -1,
        columnBaseZ + (height * gridScale) / 2 - 0.15,
    ];

    const groupRotation = [
        0,
        0,
        -positionAngle * (Math.PI / 180),
    ];

    return (
        <group position={groupPosition} rotation={groupRotation}>
            <mesh>
                <boxGeometry args={[width, 0.4, 0.4]} />
                <meshStandardMaterial color={defaultBaseColor} />
            </mesh>

            {lanterns.map((lantern, index) => {
                const offset = parseFloat(lantern.offset) || 0;
                const start = new THREE.Vector3(
                    (offset - centerOffset) * gridScale,
                    0,
                    0
                );

                const beamInfo = lantern.beamAimingInfo;
                if (!beamInfo || !beamInfo.beamEndPoint) return null;

                const { x: endX, y: endY } = beamInfo.beamEndPoint;

                const end = new THREE.Vector3(
                    (endX - adjustedX) * gridScale,
                    (endY - y) * gridScale * -1,
                    -height
                );

                const points = [start, end];
                const geometry = new THREE.BufferGeometry().setFromPoints(points);

                const luminaireIndex = luminaires.indexOf(lantern.luminaireId);
                const resolvedColor =
                    luminaireIndex !== -1 && colorList[luminaireIndex]
                        ? colorList[luminaireIndex]
                        : defaultBaseColor;

                return (
                    <line key={index} geometry={geometry}>
                        <lineBasicMaterial
                            color={resolvedColor === "#212529" ? defaultBaseColor : resolvedColor}
                            linewidth={2}
                        />
                    </line>
                );
            })}
        </group>
    );
};

export default MastWallNone;
